import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import _ from 'lodash';
import * as taxApi from '../../../lib/api/taxbill';

//@mui
import { Box, TextField, Stack, Button } from '@mui/material';
import PurchaseBillHistoryList from '../../../components/projectmng/bill_mng/PurchaseBillHistoryList';
import AskDialog from '../../../components/common/dialog/AskDialog';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  listProjectBuyTaxbills,
  listProjectInitBuyTaxbills,
  listProjectBuyPlan,
} from '../../../modules/projectModule/issue-taxbills';

//-----------------------------------------------------

//-----------------------------------------------------

const PurchaseBillHistoryContainer = ({ project, isEdit }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { buyTaxbills } = useSelector(({ projectModule }) => ({
    buyTaxbills: projectModule.issueTaxbills.buyTaxbills,
  }));

  const [histories, setHistories] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (project) {
      dispatch(listProjectBuyTaxbills(project.prjUuid));
    }
  }, [project]);

  useEffect(() => {
    if (buyTaxbills) {
      // const orderedLiist = _.orderBy(buyTaxbills, 'reqCompDt', 'desc');
      // setHistories(orderedLiist);
      setHistories(buyTaxbills);
    }
  }, [buyTaxbills]);

  const onClickDelete = (item) => {
    setVisible(true);
    setSelectedItem(item);
  };

  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
    handleDelete();
  };

  const handleDelete = async () => {
    try {
      const res = await taxApi.removeIssuedTaxbills(
        project.prjUuid,
        'B',
        selectedItem.invUuid,
      );
      if (res.data.result === 'success') {
        dispatch(listProjectBuyTaxbills(project.prjUuid));
        dispatch(listProjectInitBuyTaxbills(project.prjUuid)); //매입계산서
         dispatch(listProjectBuyPlan(project.prjUuid));
        enqueueSnackbar('매입계산서 삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [searchWord, setSearchWord] = useState('');
  const handleApplyFilter = () => {
    if (searchWord !== null && searchWord !== '') {
      const filteredData = histories.filter(
        (item) =>
          item.partnerNm.toLowerCase().indexOf(searchWord.toLowerCase()) !==
            -1 ||
          item.invTxt.toLowerCase().indexOf(searchWord.toLowerCase()) !== -1,
      );
      const orderedLiist = _.orderBy(filteredData, 'reqCompDt', 'desc');
      setHistories(orderedLiist);
    } else {
      const orderedLiist = _.orderBy(buyTaxbills, 'reqCompDt', 'desc');
      setHistories(orderedLiist);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <Stack direction="row" spacing={2} sx={{ my: 1 }} justifyContent="center">
        <TextField
          id="searchWord"
          name="searchWord"
          label="매입처 또는 매입내용을 입력하세요"
          variant="outlined"
          size="small"
          fullWidth
          value={searchWord}
          onChange={(e) => setSearchWord(e.target.value)}
        />
        <Button variant="contained" color="success" onClick={handleApplyFilter}>
          검색
        </Button>
      </Stack>
      <PurchaseBillHistoryList
        history={histories}
        isEdit={isEdit}
        onDelete={onClickDelete}
      />
      <AskDialog
        visible={visible}
        title="매입 계산서 등록 내역 삭제"
        description={`매입 계산서 등록 내역 삭제하시겠습니까?`}
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};

export default PurchaseBillHistoryContainer;
